module.exports = __webpack_public_path__ + "img/gjj-img.4d0acba9.png";